
<template>
    <div class="tableIngresos">
        <vs-button
            v-if="users != '' && status == 'timbrado'"
            :disabled="!selected.length"
            warn
            relief
            @click="activeCancelarMasivo =! activeCancelarMasivo"
            class="ml-auto"
        >
            <i class="far fa-window-close mr-2"></i> Cancelar facturas masivamente 
        </vs-button>
        <vs-row v-if="cards" class="mb-4">
            <vs-col  v-if="cards.importe_facturado" sm="12" lg="3" class="p-1">
                <div class="card md-green">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{cards.importe_facturado | currency}}</strong></h4>
                        <p class="mb-0"><strong>Importe facturado</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col  v-if="cards.importe_cancelado" sm="12" lg="3" class="p-1">
                <div class="card md-danger">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{cards.importe_cancelado | currency}}</strong></h4>
                        <p class="mb-0"><strong>Importe Cancelado</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col  v-if="cards.importe_sintimbrar" sm="12" lg="3" class="p-1">
                <div class="card md-warn">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{cards.importe_sintimbrar | currency}}</strong></h4>
                        <p class="mb-0"><strong>Importe sin timbrar</strong></p>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col w="12">
                <vs-row style="align-items: flex-end !important">
                    <h5 v-if="users.length > 0">Número total de alumnos: <strong>{{users.length}}</strong></h5>
                </vs-row>
                <cancelar v-model="activeCancelar" :multi="selected" :rows="selectedRow" :individual="selectedIndividual" @refreshTable="getRefresh" :institucion="institucion" :personaRol="personaRol"></cancelar>
                <cancelar-masivo v-model="activeCancelarMasivo" :selected="selected" @refreshTable="getRefresh"></cancelar-masivo>
                <facturar v-model="activeFacturar" :institucion="institucion" :rows="selectedRow"></facturar>
                <div style="max-width: 100%">
                     <vs-table
                        v-model="selected"
                        v-dragscroll="{ target: '.vs-table', active: true }"
                        >
                        <template #thead>
                        <vs-tr>
                            <vs-th width="40px" v-if="status == 'timbrado'">
                                <vs-checkbox
                                    v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, users)"
                                />
                            </vs-th>
                            <vs-th width="200px">
                                Alumno
                            </vs-th>
                            <vs-th width="250px">
                                Emisor
                            </vs-th>
                            <vs-th width="200px">
                                Receptor
                            </vs-th>
                            <vs-th width="200px">
                                Datos de facturación
                            </vs-th>
                            <vs-th width="150px !important">
                                Datos de pago
                            </vs-th>
                             <vs-th width="40px">
                                Acciones
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in $vs.getSearch(users, search)"
                            :data="tr"
                            style="vertical-align: top;"
                        >
                            <vs-td checkbox class="checkAlumno" v-if="status == 'timbrado'">
                                <vs-checkbox class="m-auto" :val="tr" v-model="selected" />
                            </vs-td>
                            <vs-td>
                                <md-content class="cienCincuenta d-block">
                                    <div>
                                        <p class="mb-0"><strong>{{ tr.persona.nombre_completo }}</strong></p>
                                        <p class="mb-0"><span style="text-transform: uppercase; font-size: 11px;">Matrícula</span></p>
                                        <p class="mb-0"><strong>{{ tr.persona.matricula }}</strong></p>
                                    </div>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cienCincuenta d-block">
                                    <p class="mb-1">{{ tr.institucion.nombre }}</p>

                                    <p v-if="tr.institucion.razon_social !== ''" class="mb-0"><small>RAZÓN SOCIAL</small></p>
                                    <p class="mb-1" v-if="tr.institucion.razon_social !== ''"><strong>{{ tr.institucion.razon_social }}</strong></p>
                                    
                                    <p v-if="tr.institucion.rfc !== ''" class="mb-0"><small>RFC</small></p>
                                    <p v-if="tr.institucion.rfc !== ''" class="mb-0"><strong>{{ tr.institucion.rfc }}</strong></p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content style="width: 226px">
                                    <p v-if="tr && tr.factura && tr.factura.datos_fiscales && tr.factura.datos_fiscales.razon_social" class="mb-1"><strong>{{ tr.factura.datos_fiscales.razon_social }}</strong></p>
                                    <p v-else><strong>Sin información</strong></p>

                                    <p class="mb-0"><small>RFC FISCAL</small></p>
                                    <p v-if="tr && tr.factura && tr.factura.datos_fiscales && tr.factura.datos_fiscales.rfc" class="mb-1"><strong>{{ tr.factura.datos_fiscales.rfc }}</strong></p>
                                    <p class="mb-1" v-else><strong>Sin información</strong></p>

                                    <p class="mb-0"><small>CORREO FISCAL</small></p>
                                    <p v-if="tr && tr.factura && tr.factura.datos_fiscales && tr.factura.datos_fiscales.correo" class="mb-1"><strong>{{ tr.factura.datos_fiscales.correo }}</strong></p>
                                    <p class="mb-1" v-else><strong>Sin información</strong></p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content style="width: 250px">
                                    <p class="mb-0"><small>IMPORTE</small></p>
                                    <p><strong>{{ tr.factura.importe | currency}}</strong></p>
                                    <p class="mb-0"><small>FECHA</small></p>
                                    <p v-if="tr.factura.fecha"><strong><i class="far fa-calendar-alt"></i> {{ tr.factura.fecha }}</strong></p>

                                    <p class="mb-0"><small>TIPO DE CONSULTA</small></p>
                                    <md-chip v-if="tr.factura.status" class="mb-1 fontMedium mini-chip mb-2" :class="getColorStatus(tr.factura)"><strong><span style="text-transform: capitalize;"> {{ tr.factura.status }} </span></strong></md-chip>

                                    <p class="mb-0"><small>TIPO DE FACTURA</small></p>
                                    <md-chip v-if="tr.factura.tipo_facturacion" class="mb-1 fontMedium mini-chip mb-2" :class="getColorMetodoFactura(tr.factura)"><strong><span style="text-transform: capitalize;"> {{ tr.factura.tipo_facturacion }} </span></strong></md-chip>
                                    
                                    <p class="mb-0"><small>UUID</small></p>
                                    <p class="mb-1"><strong><i class="fas fa-barcode"></i> {{ tr.factura.uuid }}</strong></p>

                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content style="width: 226px" class="d-block">
                                    <div v-if="tr.factura.uuid != ''">
                                        <p class="mb-0"><small>MÉTODO DE PAGO DE CFDI</small></p>
                                        <md-chip v-if="tr.factura.metodo_pago" class="mb-1 fontMedium mini-chip" :class="getColorMetodo(tr.factura)"><strong> {{ tr.factura.metodo_pago }} </strong></md-chip>
                                    </div>

                                    <p class="mb-0"><small>CONCEPTO(S)</small></p>
                                    <div class="mb-1" v-for="(concepto, j) in tr.factura.conceptos" :key="j">
                                        <p class="mb-1"><strong>{{ concepto.nombre }}</strong></p>
                                        
                                        <p class="mb-0"><small>FECHA</small></p>
                                        <p class="mb-1"><strong><i class="far fa-calendar-alt"></i> {{ concepto.fecha_pago }}</strong></p>

                                        <p class="mb-0"><small>MONTO</small></p>
                                        <p class="mb-1"><strong>{{ concepto.monto | currency}}</strong></p>
                                        <hr v-if="tr.factura.conceptos.length > 1">
                                    </div>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-menu md-size="small"  md-align-trigger>
                                    <md-button class="md-icon-button" md-menu-trigger>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </md-button>

                                    <md-menu-content>
                                        <!-- <md-menu-item style="border-bottom: 1px solid gray;" 
                                        :href="`/estado-de-cuenta/${tr.persona.id}/gestion`" target="_blank">
                                           Ir a Gestión finanzas
                                        </md-menu-item> -->
                                        <md-menu-item v-if="tr.factura.status === 'timbrado'" @click="getDescargar(tr, 'xml')">
                                           Descargar XML
                                        </md-menu-item>
                                        <md-menu-item v-if="tr.factura.status === 'timbrado'" @click="getDescargar(tr, 'pdf')">
                                           Descargar PDF
                                        </md-menu-item>
                                        <md-menu-item v-if="status == 'ingresosvsfacturas' && tr.factura.status != 'timbrado'" @click="activeFacturar =! activeFacturar; facturarPagos(selectedRow = tr)">
                                            Facturar
                                        </md-menu-item>
                                        <md-menu-item style="border-top: 1px solid gray;" v-if="tr.factura.status === 'timbrado'" @click="activeCancelar = !activeCancelar;  selectedRow = tr; selectedIndividual = tr.factura">
                                            Cancelar factura
                                        </md-menu-item>
                                    </md-menu-content>
                                </md-menu>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import cancelar from './modal/cancelar.vue'
import facturar from './modal/facturar.vue'
import CancelarMasivo from './modal/cancelar-factura-masiva.vue'
import reportes from '../../../../api/requests/reportes.js'
import cobranza from '../../../../api/requests/cobranza-persona.js'

export default {
    props: [
        'users',
        'institucion',
        'status',
        'cards',
        'personaRol'
    ],
    data(){
        return {
            search: '',
            allCheck: false,
            active: 0,
            selected: [],
            colorMetodo: {
                "Efectivo": "green",
                "Cheque nominativo": "yellow",
                "Transferencia electrónica de fondos": "blue",
                "Tarjeta de crédito" : "red",
                "Monedero electrónico": 'purple',
                "Dinero electrónico": "gray",
                "Vales de despensa": "pink",
                "Dación en pago": "brown",
                "Pago por subrogación": "green",
                "Pago por consignación": "yellow",
                "Condonación" : "blue",
                "Compensación" : "red",
                "Novación": 'purple',
                "Confusión": "gray",
                "Remisión de deuda": "pink",
                "Prescripción o caducidad": "brown",
                "A satisfacción del acreedor": "green",
                "Tarjeta de débito": "yellow",
                "Tarjeta de servicios" : "blue",
                "Aplicación de anticipos" : "red",
                "Intermediario Pagos": 'purple',
                "Por definir": "gray"
            },
            colorFactura: {
                "Genérica": "purple",
                "Personalizada": "brown",
                "generica": "purple",
                "personalizada": "brown",
            },
            colorStatus: {
                "timbrado": "green",
                "cancelado": "red",
                "sin_timbrar": "yellow",
                "Timbrado": "green",
                "Cancelado": "red",
                "Sin timbrar": "yellow"
            },
            colorFuente: {
                "Pagos": "green",
                "Conciliacion bancaria": "blue",
                "Conciliacion de pagos": "pink",
            },
            activeCancelar: false,
            selectedRow: [],
            selectedIndividual: [],
            activeFacturar: false,
            activeCancelarMasivo: false
        }
    },
    components: {
        cancelar,
        facturar,
        CancelarMasivo
    },
    methods: {
        getColorMetodo(status){
            if (status.metodo_pago === 'Efectivo'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Cheque nominativo'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Transferencia electrónica de fondos'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Tarjeta de crédito'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Monedero electrónico'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Dinero electrónico'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Vales de despensa'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Dación en pago'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Pago por subrogación'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Pago por consignación'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Condonación'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Compensación'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Confusión'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Novación'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Remisión de deuda'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Prescripción o caducidad'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'A satisfacción del acreedor'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Tarjeta de débito'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Tarjeta de servicios'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Aplicación de anticipos'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Intermediario Pagos'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }else if (status.metodo_pago === 'Por definir'){
                return `col-${this.colorMetodo[status.metodo_pago]}`
            }
        },
        getColorMetodoFactura(status){
            if (status.tipo_facturacion === 'Genérica'){
                return `col-${this.colorFactura[status.tipo_facturacion]}`
            }else if (status.tipo_facturacion === 'Personalizada'){
                return `col-${this.colorFactura[status.tipo_facturacion]}`
            }else if (status.tipo_facturacion === 'generica'){
                return `col-${this.colorFactura[status.tipo_facturacion]}`
            }else if (status.tipo_facturacion === 'personalizada'){
                return `col-${this.colorFactura[status.tipo_facturacion]}`
            }
        },
        getColorStatus(status){
            if (status.status === 'timbrado'){
                return `col-${this.colorStatus[status.status]}`
            }else if (status.status === 'timbrado'){
                return `col-${this.colorStatus[status.status]}`
            }else if (status.status === 'Cancelado'){
                return `col-${this.colorStatus[status.status]}`
            }else if (status.status === 'cancelado'){
                return `col-${this.colorStatus[status.status]}`
            }else if (status.status === 'Sin timbrar'){
                return `col-${this.colorStatus[status.status]}`
            }else if (status.status === 'sin_timbrar'){
                return `col-${this.colorStatus[status.status]}`
            }
        },
        getColorFuente(status){
            if (status.fuente_movimiento.nombre === 'Pagos'){
                return `col-${this.colorFuente[status.fuente_movimiento.nombre]}`
            }else if (status.fuente_movimiento.nombre === 'Conciliacion bancaria'){
                return `col-${this.colorStatus[status.fuente_movimiento.nombre]}`
            }else if (status.fuente_movimiento.nombre === 'Conciliacion de pagos'){
                return `col-${this.colorStatus[status.fuente_movimiento.nombre]}`
            }
        },
        async getDescargar(info , type){
            try {
                const persona = info.persona.id
                const id_concepto = info.factura.conceptos[0].id
                const uuid = info.factura.uuid
                const response = await reportes.getFacturaTemp(persona , id_concepto, type, uuid)
                this.dowloadFile(response.data, response.headers)
            } catch (error) {
                console.log(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salio mal',
                })
            }
           
           
        },
        dowloadFile(blob, headers){
            if (blob instanceof Blob) {
                const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                var filename = "";
                const disposition = headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                        link.setAttribute('download', filename)
                    }
                }
                document.body.appendChild(link);
                link.click();
                link.remove();
            }else{
                throw { message: 'formatError' }
            }
        },
        getRefresh(){
            this.selected = []
            this.activeCancelar = false
            this.$emit('refreshTableFactura',true)
        },
        
        async facturarPagos () {
                    const vm = this
                            const infoPago = []
                            const conceptos = vm.selectedRow.factura.conceptos
                            conceptos.forEach(i => {
                                infoPago.push(i.id)
                            })
                            let params = {
                                id: vm.selectedRow.persona.id,
                                ciclo_escolar: this.cicloEscolar,
                                institucion: this.institucion,
                                pagos : infoPago
                            }

                            console.log(params)
                            return
                        try {
                            const { data: response = null } = 
                            await cobranza.postFacturar(params) 
                            // { data: { uuids: ['1','2','3'] } }
                            || {}
                            this.$emit('endLoading')
                            if (response && response.uuids && response.uuids != '' ){
                                this.$vs.notification({
                                    progress: 'auto',                           
                                    color: 'success',
                                    position: null,
                                    title: 'UUID facturado',
                                    text: response.uuids
                                })                                

                                this.listPagos = []
                                vm.selectedRow = []
                                this.getPagos()
                              
                            }else {
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: 'Algo salió mal contacta al Administrador'
                                })
                            }

                          
                        } catch (error) {
                            console.log(error)
                            this.$emit('endLoading')
                             if (error.response.data && error.response.data.errores){
                                const data = error.response.data.errores
                                if (data.descripcion){
                                    this.$vs.notification({
                                        progress: 'auto',
                                        color: 'danger',
                                        position: null,
                                        title: 'Error',
                                        text: data.descripcion
                                    })
                                }
                            }else{
                                this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Error',
                                text: `Algo salió mal`
                                })
                            }
                        }
        },
    },
    watch: {
        users (){
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .domicializar .vs-dialog{
        max-width: 95% !important;
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .sesenta{
        width: 60px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienTreinta {
        width: 130px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .docientosCincuenta{
        width: 250px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .sinBorde{
        border: 1px solid red;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

    .cienCincuenta .vs-avatar__badge{
        font-size: 0.9rem !important;
        padding: 3px;
    }

    .cienCincuenta .vs-button__content{
        padding: 5px 10px !important;
    }

    .cienTreinta .vs-button__content{
        padding: 5px 10px !important;
    }
    .sesenta .md-icon-button{
        height: 35px !important;
    }
    .md-content.md-theme-default{
        background: none !important;
    }

    .vertical-top{
        vertical-align: top !important;
        padding-top: 0;
    }
    

    .md-warn{
        background: #ffbc34;
        color: white;
        border-radius: 7px;
    }

    .md-green{
        background: #52BE80;
        color: white;
        border-radius: 7px;
    }

    .md-danger{
        background:#C0392B;
        color: white;
        border-radius: 7px;
    }

</style>

        